import { inputReg } from "@/static/inputReg";

export const strFilter = (v, keys) => {
  let result = v;
  for (let i = 0; i < keys.length; i++) {
    const reg = inputReg.get(keys[i]);
    if (reg) {
      result = result.replace(reg, "");
    }
    if (keys[i].includes("decimal_") && /[\d]/g.test(keys[i].split("_")[1]) && +keys[i].split("_")[1] > 0) {
      const length = +keys[i].split("_")[1];
      result = handleDecimal(result, length);
    }
  }
  return result;
};

const handleDecimal = (v, length) => {
  v = v.replace(/[^\d.]/g, "");
  let parts = v.split(".");
  if (parts.length > 2) {
    v = parts[0] + "." + parts.slice(1).join("");
  }
  parts = v.split(".");
  if (parts.length === 2 && parts[1].length > length) {
    v = parts[0] + "." + parts[1].substring(0, length);
  }
  return v;
};
